import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/chatbot.css";
import "./styles/property-map-preview.css";
import "./styles/credit-card.css";
import App from "./App";
import { CookiesProvider } from "react-cookie";
import * as serviceWorker from "./serviceWorker";
// mutation-events is a polyfill for MutationObserver
// this is used to automatically scroll to the bottom of the chat window after a new message is added
// eslint-disable-next-line no-unused-vars
import * as mutationEvents from "mutation-events";

ReactDOM.render(
  <CookiesProvider>
    <App />
  </CookiesProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
